<template>
    <div>
        <div class="app-wrapper pt-20">
            <DHeader @childToParent="updateDHeader"/>
        </div>


        <div class="container-xxl">

            <div class="content">
                <MyTopheader/>
                <router-view v-slot="{ Component }">
                    <component :is="Component" />

                </router-view>
            </div>
        </div>

        <DFooter/>
        <ScrollTopArrow/>
    </div>

</template>
<script>
import DHeader from '../views/components/partials/DHeader'
import DFooter from '../views/components/partials/DFooter'
import MyTopheader from '../views/components/partials/MyTopheader'
import ScrollTopArrow from '../views/components/partials/ScrollTopArrow'

export default {
    name: 'UserLayout',
    components: {
        DHeader,
        DFooter,
        MyTopheader,
        ScrollTopArrow
    },
    methods: {
        updateDHeader(data) {
            this.show_sidebar = data;
        },
    },
    data () {
        return {
            show_sidebar: false
        }
    }
}
</script>
<style>

</style>
